export default "__VITE_ASSET__fe658dfe__"